// Each idea page's own words, loaded with the page (App.tsx), apart from the labels in index.js so the app's
// entry carries only these few lines.
export const IDEA_LOADERS = {
  es: {
    hub: () => import('./es/hub.js'),
    terror: () => import('./es/terror.js'),
    curiosidades: () => import('./es/curiosidades.js'),
    historia: () => import('./es/historia.js'),
    mysteries: () => import('./es/mysteries.js'),
    animals: () => import('./es/animals.js'),
    finanzas: () => import('./es/finanzas.js'),
    quiz: () => import('./es/quiz.js'),
    pov: () => import('./es/pov.js'),
    leyendas: () => import('./es/leyendas.js'),
    infantiles: () => import('./es/infantiles.js'),
    motivacion: () => import('./es/motivacion.js'),
    objetos: () => import('./es/objetos.js'),
  },
  pt: {
    hub: () => import('./pt/hub.js'),
    terror: () => import('./pt/terror.js'),
    curiosidades: () => import('./pt/curiosidades.js'),
    historia: () => import('./pt/historia.js'),
    mysteries: () => import('./pt/mysteries.js'),
    animals: () => import('./pt/animals.js'),
    finanzas: () => import('./pt/finanzas.js'),
    quiz: () => import('./pt/quiz.js'),
    pov: () => import('./pt/pov.js'),
    leyendas: () => import('./pt/leyendas.js'),
    infantiles: () => import('./pt/infantiles.js'),
    motivacion: () => import('./pt/motivacion.js'),
    objetos: () => import('./pt/objetos.js'),
  },
};

// The Arabic pages, for the Gulf (ar/index.js AR_IDEA_IDS)
IDEA_LOADERS.ar = {
  hub: () => import('./ar/hub.js'),
  'gulf-horror': () => import('./ar/gulf-horror.js'),
  'gulf-curiosities': () => import('./ar/gulf-curiosities.js'),
  'gulf-history': () => import('./ar/gulf-history.js'),
  'snapchat-ads': () => import('./ar/snapchat-ads.js'),
  'gulf-quiz': () => import('./ar/gulf-quiz.js'),
};
